export const SETTINGS_FEATURE_FLAG = 'rollout.business.pov_settings_page';
export const NEW_PROFILE_PAGE_FLAG = 'new_profile_page';
export const ANGULAR_SETTINGS_ROUTE = 'app.settings';
export const SETTINGS_ROUTE_NAME = 'settings';

export const VOICE_CALLS_APP_CODE_NAME = 'voicecallsinternal';
export const RESOURCES_PACKAGE_FLAG = 'pkg.sch.resources';
export const UPGRADE_TOOLTIP = 'upgrade';

export const SETTINGS_CATEGORY = {
  BUSINESS_SETTINGS: 'business_settings',
  BUSINESS_SERVICES: 'business_services',
  STAFF_SETTINGS: 'staff_settings',
};

export const SETTINGS_CATEGORY_CLASS = {
  [SETTINGS_CATEGORY.BUSINESS_SETTINGS]: 'settings_business',
  [SETTINGS_CATEGORY.BUSINESS_SERVICES]: 'settings_livesite',
  [SETTINGS_CATEGORY.STAFF_SETTINGS]: 'settings_system',
};

export const SETTINGS_CATEGORY_COLOR = {
  settings_business: '#efc74a',
  settings_livesite: '#81c884',
  settings_system: '#c06fc0',
};

// Legacy Angular SettingsLayout.updateSettingsListInMobile: pages the native app does not open.
// The legacy list also named 'calendar' and 'tracking', tiles the current factory never builds.
export const MOBILE_APP_HIDDEN_TILES = ['staff', 'account', 'email'];

export const TRACKING = {
  PAGE_VIEW: 'Settings Page View',
  ITEM_CLICK: 'Settings Page Item Click',
  RESOURCES_CLICK: 'resource_tile_click',
  ROLES_CLICK: 'Settings - Roles And Permissions Click',
};
